'use client';

import React from 'react';
import styled from 'styled-components';
import PromotionalBanner from './PromotionalBanner';

const HeroWireframe = () => {
  return (
    <TopSection>
      <HeroSection>
        <PromotionalBanner />
      </HeroSection>
    </TopSection>
  );
};

export default HeroWireframe;

const TopSection = styled.div`
  padding-top: 120px;
  width: 100%;
  box-sizing: border-box;
  /* Matches the fixed header stack's own black background, so the small
     safety-buffer gap left by padding-top (clearing the real ~112px header
     height) blends into the header instead of showing as a pale seam. */
  background-color: #1a1a1a;

  @media (max-width: 912px) {
    padding-top: 125px;
  }
`;

const HeroSection = styled.section`
  width: 100%;
  background-color: #fafafa;
  text-align: center;
  @media (max-width: 767px) {
    padding: 0;
  }
`;
